export default "__VITE_ASSET__BH04ECA3__"